import React, { Component } from "react";
import { Link } from "react-router-dom";
import { ccy2cc, cc2ccy, getURLParameters } from "./../lib/utils";
import i18n from "i18next";
import { ccyList, fxList } from "./../lib/constants";
import axios from "axios";
import Chart5 from "./../Components/Charts/Chart5";
import { ReactComponent as ArrowUpIcon } from "./../img/arrow-up.svg";
import { ReactComponent as ArrowDownIcon } from "./../img/arrow-down.svg";
import "./FXWidget.css";
import Navbar from "../Components/Navbar";
import VideoBox from "../Components/Commentary/VideoBox";
import { APIAddress } from "../lib/apiAddressEnum";
import DataLoader from "../lib/DataLoader";

const ccyVideoList = ["USD", "EUR", "GBP", "AUD", "NZD", "CAD", "JPY", "CHF"];
export default class FXWidget extends Component<any, any> {
  chartRef: any;
  IntervalID: any;
  constructor(props: any) {
    super(props);
    this.chartRef = React.createRef();
    this.IntervalID = 0;
    this.state = {
      lang: this.props.lang,
      token: this.props.token,
      Currency: cc2ccy(this.props.cc) || "HKD",
      ChartIndex: "",
      data: [],
      previousdata: [],
      detaildata: [],
      Newsdata: [],
      newslang: "ALL",
      fontSize: this.props.fontSize,

      //chart
      compare: "",
      type: "",
      overlay: "",
      overlayConfig: "",
      tapane: "",
      tapaneConfig: "",
      period: "3M",
    };
  }
  FXRateAPI = (Currency: string, isFirstRender: boolean) => {
    let allFX = "";
    for (let i = 0; i < fxList.length; i++) {
      if (
        fxList[i].cd.substring(0, 3) === Currency ||
        fxList[i].cd.substring(3, 6) === Currency
      ) {
        allFX = allFX + fxList[i].cd + ",";
      }
    }
    const base_url = this.props.domain + "/bochkfxwidget/data/quote?";
    const detail = "0";
    let underscore = new Date().getTime();
    const url =
      base_url +
      "fx=" +
      allFX +
      "&detail=" +
      detail +
      "&lang=" +
      this.state.lang +
      "&_=" +
      underscore +
      "&token=" +
      this.state.token;

    axios.get(url).then((res) => {
      if (isFirstRender) {
        if (res.data.data.quote.length >= 0) {
          this.NewsHeaderAPI(res.data.data.quote[0].fx);
          this.FXRateDetailAPI(res.data.data.quote[0].fx);
          this.setState({
            ChartIndex: res.data.data.quote[0].fx,
            data: { status: "loaded", payload: res.data },
            previousdata: [],
          });
        }
      } else {
        this.setState((prevState: any) => ({
          data: { status: "loaded", payload: res.data },
          previousdata: prevState.data,
        }));
      }
    });
  };

  FXRateDetailAPI = (fx: string) => {
    const base_url = this.props.domain + "/bochkfxwidget/data/quote?";
    const detail = "1";
    let underscore = new Date().getTime();
    const url =
      base_url +
      "fx=" +
      fx +
      "&detail=" +
      detail +
      "&lang=" +
      this.state.lang +
      "&_=" +
      underscore +
      "&token=" +
      this.state.token;

    axios.get(url).then((res) => {
      this.setState({
        detaildata: { status: "loaded", payload: res.data },
      });
    });
  };

  NewsHeaderAPI = (region: string) => {
    let base_url = this.props.domain + "/bochkfxwidget/data/news?";
    let newstype = "IDN";
    let underscore = new Date().getTime();
    let cc =
      "(" +
      ccy2cc(region.substring(0, 3)) +
      "|" +
      ccy2cc(region.substring(3, 6)) +
      ")";
    let url =
      base_url +
      "newstype=" +
      newstype +
      "&newslang=" +
      this.state.newslang +
      "&lang=" +
      this.state.lang +
      "&rpp=" +
      6 +
      "&cc=" +
      cc +
      "&pn=" +
      1 +
      "&_=" +
      underscore +
      "&token=" +
      this.state.token;
    axios.get(url).then((res) => {
      this.setState({ Newsdata: { status: "loaded", payload: res.data } });
    });
  };

  componentDidMount = () => {
    window.addEventListener("resize", this.updateDimensions);
    this.props.history.push(
      "/mktinfo?lang=" + this.props.lang + "&cc=" + this.props.cc
    );
    this.FXRateAPI(this.state.Currency, true);
    this.IntervalID = setInterval(
      function (this: any) {
        this.FXRateAPI(this.state.Currency, false);
        this.FXRateDetailAPI(this.state.ChartIndex);
      }.bind(this),
      5000
    );

    this.ForeignExchangeAPI(this.props);
    this.MarketProspectAPI(this.props);
    this.props.widget(false);
  };

  componentWillUnmount() {
    clearInterval(this.IntervalID);
    window.removeEventListener("resize", this.updateDimensions);
  }

  updateDimensions = () => {
    this.chartRef.current.resizeChart("");
  };

  componentWillReceiveProps(nextProps: any) {
    // clearInterval(this.IntervalID);
    if (nextProps.lang !== this.props.lang) {
      this.props.history.push(
        "/mktinfo?lang=" + nextProps.lang + "&cc=" + nextProps.cc
      );
    }
  }

  changeSelect = (event: React.FormEvent<HTMLSelectElement>) => {
    this.setState({ Currency: event.currentTarget.value });
    this.FXRateAPI(event.currentTarget.value, true);
  };

  selectTable = (fx: string) => {
    this.NewsHeaderAPI(fx);
    this.FXRateDetailAPI(fx);
    this.setState({ ChartIndex: fx });
  };

  converter = (fx: string) => {
    return (
      i18n.t("Common." + fx.substring(0, 3), "") +
      "/" +
      i18n.t("Common." + fx.substring(3, 6), "")
    );
  };

  removeSign = (pc: string) => {
    if (pc[0] === "+" || pc[0] === "-") {
      return pc.substr(1);
    }
    return pc;
  };

  fitAPIlang = () => {
    if (this.props.lang === "en") {
      return "en_US";
    } else {
      return this.props.lang;
    }
  };

  parseVideoDate(value: string) {
    if (value && value.length === 19) {
      // let d = new Date(value);

      return (
        value.substring(0, 4) +
        "/" +
        value.substring(5, 7) +
        "/" +
        value.substring(8, 10)
      );

      // if (d){
      //   return d.toLocaleString("en-us", {year: 'numeric'}) + '/' + d.toLocaleString("en-us", {month: '2-digit'}) + '/' + d.toLocaleString("en-us", {day: '2-digit'});
      // }
    }
    return "";
  }

  ForeignExchangeAPI(props: any) {

    let base_url = this.props.domain + "/bochkfxwidget/data/commentary?";

    let url =
      base_url +
      "type=ForeignExchange" +
      "&lang=" +
      this.props.lang +
      "&cc=" +
      this.state.cc +
      "&token=" +
      this.state.token +
      "&_=" + new Date().getTime();

    axios.get(url).then((res) => {
      this.setState({ FXdata: { status: "loaded", payload: res.data } });
    });

    // const param = {
    //   token: props.token,
    //   lang: props.lang,
    //   type: "ForeignExchange",
    //   cc: this.state.cc,
    //   _: new Date().getTime(),
    // };

    // let address = APIAddress.commentary;
    // const raw = DataLoader(address, param);

    // raw.then((data) => {
    //   this.setState({ FXdata: { status: "loaded", payload: data } });
    // });
  }

  MarketProspectAPI(props: any) {

    let base_url = this.props.domain + "/bochkfxwidget/data/commentary?";

    let url =
      base_url +
      "type=MarketProspect" +
      "&lang=" +
      this.props.lang +
      "&cc=" +
      this.state.cc +
      "&token=" +
      this.state.token +
      "&_=" + new Date().getTime();

    axios.get(url).then((res) => {
      this.setState({ MPdata: { status: "loaded", payload: res.data } });
    });
    // const param = {
    //   token: props.token,
    //   lang: props.lang,
    //   type: "MarketProspect",
    //   cc: this.state.cc,
    //   _: new Date().getTime(),
    // };

    // let address = APIAddress.commentary;
    // const raw = DataLoader(address, param);

    // raw.then((data) => {
    //   this.setState({ MPdata: { status: "loaded", payload: data } });
    // });
  }


  createForecast = () => {
    if (this.state.MPdata && this.state.MPdata.status === "loaded") {
      var data = this.state.MPdata.payload;
      //var latestDateIndex = -1;
      var latestDateIndex = 0;
      var latest = data.result[this.fitAPIlang()][0]["sortingDate"];
      for (let i = 1; i < data.result[this.fitAPIlang()].length; i++) {
        if (latest > data.result[this.fitAPIlang()][i]["sortingDate"]) {
        } else {
          latest = data.result[this.fitAPIlang()][i]["sortingDate"];
          latestDateIndex = i;
        }
      }

      let curIndex = -1;
      for (
        let i = 0;
        i < data.result[this.fitAPIlang()][latestDateIndex]["array"].length;
        i++
      ) {
        if (this.state.ccy !== "ALL") {
          if (
            data.result[this.fitAPIlang()][latestDateIndex]["array"][i][
            "id"
            ] === this.state.ccy
          ) {
            curIndex = i;
            break;
          }
        } else {
          if (
            data.result[this.fitAPIlang()][latestDateIndex]["array"][i][
            "id"
            ] === this.state.selectedccy
          ) {
            curIndex = i;
            break;
          }
        }
      }

      var newCCYList: string[] = [];
      if (this.state.FXdata && this.state.FXdata.status === "loaded") {
        let data = this.state.FXdata.payload.result[this.fitAPIlang()];
        for (let i = 0; i < data.length; i++) {
          let video = data[i];
          if (data[i].category === "fx_daily") {
            newCCYList.splice(0, 0, video.tag);
          }
        }

        ccyVideoList.forEach((element: string) => {
          if (!newCCYList.includes(element)) {
            newCCYList.push(element);
          }
        });
      }

      return <div>{this.renderWeeklyVideo()}</div>;
    }
  };

  renderWeeklyVideo() {
    if (this.state.FXdata && this.state.FXdata.status === "loaded") {
      let data = this.state.FXdata.payload.result[this.fitAPIlang()];
      for (let i = 0; i < data.length; i++) {
        let video = data[i];
        if (video.category === "fx_weekly") {
          let lang = video.languageText;
          let fullDescText = video.fullDescText;
          let desc = [];
          while (fullDescText.length > 0) {
            let startidx = fullDescText.indexOf("<p>");
            let endidx = fullDescText.indexOf("</p>");
            desc.push(
              fullDescText.substr(startidx + 3, endidx - (startidx + 3))
            );
            fullDescText = fullDescText.substr(endidx + 4).trim();
          }

          let style = { "font-weight": "900", "color": "#a00" }

          return (
            <div className="Fx-Forecast-Video">
              <VideoBox
                category=""
                lang={lang}
                speaker={desc[0]}
                content={desc[1]}
                title={video.titleText}
                video={video.videoURL}
                thumbnail={video.videoThumbnail}
                date={this.parseVideoDate(video.sortingDate)}
                style={style}
              />
            </div>
          );
        }
      }
    }
  }

  render() {
    return (
      <div>
        <Navbar lang={this.state.lang} cc={this.props.cc} />
        <div
          className="content"
          style={{ fontSize: this.props.fontSize || "100%" }}
        >
          <div className="title">{i18n.t("Home.Title")}</div>
          <div className="select_container">
            {i18n.t("Home.AllCurrency")}
            <select
              onChange={(e) => this.changeSelect(e)}
              value={this.state.Currency}
            >
              {ccyList.map(function (item, i) {
                return (
                  <option key={i} value={item.cd}>
                    {i18n.t("Common." + item.cd)}
                  </option>
                );
              })}
            </select>
          </div>

          <div className="Content-Container">
            <div className="Left-Container">
              <div className="Market-Table-Header">
                <div className="Market-Table-Col1">
                  {i18n.t("Common.Currency")}
                </div>
                <div className="Market-Table-Col2">
                  {i18n.t("Common.ClientSell")}
                </div>
                <div className="Market-Table-Col3">
                  {i18n.t("Common.ClientBuy")}
                </div>
              </div>
              {this.state.data !== undefined &&
                this.state.data !== null &&
                this.state.data.status === "loaded" &&
                this.state.data.payload.data.quote &&
                this.state.data.payload.data.quote.map(
                  (item: any, index: number) => {
                    return (
                      <div
                        key={index}
                        className={
                          "Market-Table-Data" +
                          (this.state.ChartIndex === item.fx ? " selected" : "")
                        }
                        onClick={() => this.selectTable(item.fx)}
                      >
                        <div className="Market-Table-Col1">
                          {this.converter(item.fx)}
                        </div>

                        <div className="Market-Table-Col2">
                          <div
                            className={
                              "Data-Border" +
                              (this.state.previousdata !== undefined &&
                                this.state.previousdata !== null &&
                                this.state.previousdata.status === "loaded" &&
                                this.state.previousdata.payload.data.quote[
                                index
                                ] &&
                                this.state.previousdata.payload.data.quote[index]
                                  .bd &&
                                Number(
                                  this.state.previousdata.payload.data.quote[
                                    index
                                  ].bd
                                ) < Number(item.bd) &&
                                this.state.previousdata.payload.data.quote[index]
                                  .fx === item.fx
                                ? " rise"
                                : this.state.previousdata !== undefined &&
                                  this.state.previousdata !== null &&
                                  this.state.previousdata.status === "loaded" &&
                                  this.state.previousdata.payload.data.quote[
                                  index
                                  ] &&
                                  this.state.previousdata.payload.data.quote[
                                    index
                                  ].bd &&
                                  Number(
                                    this.state.previousdata.payload.data.quote[
                                      index
                                    ].bd
                                  ) > Number(item.bd) &&
                                  this.state.previousdata.payload.data.quote[
                                    index
                                  ].fx === item.fx
                                  ? " drop"
                                  : "")
                            }
                          >
                            {item.bd.substring(0, item.bd.length - 2)}
                          </div>
                        </div>

                        <div className="Market-Table-Col3">
                          <div
                            className={
                              "Data-Border" +
                              (this.state.previousdata !== undefined &&
                                this.state.previousdata !== null &&
                                this.state.previousdata.status === "loaded" &&
                                this.state.previousdata.payload.data.quote[
                                index
                                ] &&
                                this.state.previousdata.payload.data.quote[index]
                                  .as &&
                                Number(
                                  this.state.previousdata.payload.data.quote[
                                    index
                                  ].as
                                ) < Number(item.as) &&
                                this.state.previousdata.payload.data.quote[index]
                                  .fx === item.fx
                                ? " rise"
                                : this.state.previousdata !== undefined &&
                                  this.state.previousdata !== null &&
                                  this.state.previousdata.status === "loaded" &&
                                  this.state.previousdata.payload.data.quote[
                                  index
                                  ] &&
                                  this.state.previousdata.payload.data.quote[
                                    index
                                  ].as &&
                                  Number(
                                    this.state.previousdata.payload.data.quote[
                                      index
                                    ].as
                                  ) > Number(item.as) &&
                                  this.state.previousdata.payload.data.quote[
                                    index
                                  ].fx === item.fx
                                  ? " drop"
                                  : "")
                            }
                          >
                            {item.as.substring(0, item.as.length - 2)}
                          </div>
                        </div>
                      </div>
                    );
                  }
                )}
            </div>
            <div className="Right-Container">
              {this.createForecast()}
              <div className="currency">
                {this.state.detaildata.status === "loaded"
                  ? this.converter(this.state.ChartIndex)
                  : ""}
              </div>
              <div className="Basic-Info">
                <div className="Current-Change">
                  <span className="Current-Change-title">
                    {i18n.t("Chart.DailyChange")}
                  </span>
                  {this.state.detaildata.status === "loaded" ? (
                    parseFloat(this.state.detaildata.payload.data.quote[0].nc) <
                      0 ? (
                        <span className="Current-Change-nc drop">
                          {this.state.detaildata.payload.data.quote[0].nc}
                        </span>
                      ) : (
                        <span className="Current-Change-nc rise">
                          {this.state.detaildata.payload.data.quote[0].nc}
                        </span>
                      )
                  ) : (
                      ""
                    )}
                  {this.state.detaildata.status === "loaded" ? (
                    parseFloat(this.state.detaildata.payload.data.quote[0].nc) <
                      0 ? (
                        <span className="Current-Change-pc drop">
                          {"("}
                          <ArrowDownIcon className="arrow-down" />{" "}
                          {this.removeSign(
                            this.state.detaildata.payload.data.quote[0].pc
                          )}
                          {")"}
                        </span>
                      ) : (
                        <span className="Current-Change-pc rise">
                          {"("}
                          <ArrowUpIcon className="arrow-up" />
                          {this.removeSign(
                            this.state.detaildata.payload.data.quote[0].pc
                          )}
                          {")"}
                        </span>
                      )
                  ) : (
                      ""
                    )}
                </div>
                <div className="Previous-Price">
                  <span className="Previous-Price-Header">
                    {i18n.t("Chart.PClose")}
                  </span>
                  <span className="Previous-Price-Data">
                    {this.state.detaildata.status === "loaded"
                      ? this.state.detaildata.payload.data.quote[0].hc
                      : ""}
                  </span>
                </div>
              </div>

              <div className="chart">
                <div className="chart-detail">
                  <Link
                    to={{
                      pathname: "/chart",
                      search:
                        "?lang=" +
                        this.state.lang +
                        "&cc=" +
                        getURLParameters("cc"),
                      state: {
                        ccy: this.state.ChartIndex,
                      },
                    }}
                  >
                    {i18n.t("Common.GraphDetail")}
                  </Link>
                </div>
                <Chart5
                  ref={this.chartRef}
                  token={this.props.token}
                  fontsize={this.props.fontsize}
                  enableScrollPane={false}
                  full={this.state.fullChart}
                  ccy={this.state.ChartIndex}
                  compare={this.state.compare}
                  type={this.state.type}
                  overlay={this.state.overlay}
                  overlayConfig={this.state.overlayConfig}
                  tapane={this.state.tapane}
                  tapaneConfig={this.state.tapaneConfig}
                  period={this.state.period}
                  domain={this.props.domain}
                ></Chart5>
              </div>

              <div className="Variation-Title">{i18n.t("Chart.Range")}</div>
              <div className="Variation-Container">
                <div className="Variation-SubContainer">
                  <div className="Header">{i18n.t("Chart.Range_1W")}</div>
                  <div className="Data">
                    {this.state.detaildata.status === "loaded" &&
                      this.state.detaildata.payload.data.quote[0].h1w
                      ? this.state.detaildata.payload.data.quote[0].h1w.rnglo +
                      " - " +
                      this.state.detaildata.payload.data.quote[0].h1w.rnghi
                      : "-"}
                  </div>
                </div>
                <div className="Variation-SubContainer">
                  <div className="Header">{i18n.t("Chart.Range_1M")}</div>
                  <div className="Data">
                    {this.state.detaildata.status === "loaded" &&
                      this.state.detaildata.payload.data.quote[0].h1m
                      ? this.state.detaildata.payload.data.quote[0].h1m.rnglo +
                      " - " +
                      this.state.detaildata.payload.data.quote[0].h1m.rnghi
                      : "-"}
                  </div>
                </div>
                <div className="Variation-SubContainer">
                  <div className="Header">{i18n.t("Chart.Range_52W")}</div>
                  <div className="Data">
                    {this.state.detaildata.status === "loaded" &&
                      this.state.detaildata.payload.data.quote[0].h1y
                      ? this.state.detaildata.payload.data.quote[0].h1y.rnglo +
                      " - " +
                      this.state.detaildata.payload.data.quote[0].h1y.rnghi
                      : "-"}
                  </div>
                </div>
              </div>

              <div className="Related-News-Header-Container">
                <div className="Related-News-Header">
                  {i18n.t("Common.RelatedNews")}
                </div>
                <div className="Related-News-More">
                  <Link
                    to={{
                      pathname: "/news",
                      search:
                        "?lang=" +
                        this.state.lang +
                        "&cc=" +
                        getURLParameters("cc"),
                      state: {
                        scrollToTop: true,
                        cc: ccy2cc(this.state.Currency),
                      },
                    }}
                  >
                    {i18n.t("Home.More")}
                  </Link>
                </div>
              </div>
              <div className="Related-News-Container">
                {this.state.Newsdata.status === "loaded" &&
                  this.state.Newsdata.payload.data.news.map(
                    (item: any, index: number) => {
                      return (
                        <div className="Related-News" key={index}>
                          <div className="Time">
                            <div>
                              {item.dt.substring(6, 8)}/
                              {item.dt.substring(4, 6)}
                            </div>
                            <div>
                              {item.dt.substring(8, 10)}:
                              {item.dt.substring(10, 12)}
                            </div>
                          </div>
                          <div className="Title">
                            <Link
                              to={{
                                pathname: "/news",
                                search:
                                  "?lang=" +
                                  this.state.lang +
                                  "&cc=" +
                                  getURLParameters("cc"),
                                state: {
                                  newsStoryID: item.id,
                                  isModalOpen: true,
                                  scrollToTop: true,
                                  cc: ccy2cc(this.state.Currency),
                                },
                              }}
                            >
                              {item.hl}
                            </Link>
                          </div>
                        </div>
                      );
                    }
                  )}
              </div>
            </div>
          </div>
          <br />
          <br />
          <br />
          {i18n.t("Common.Update")}
          {this.state.data !== undefined &&
            this.state.data !== null &&
            this.state.data.status === "loaded"
            ? this.state.data.payload.data.lastupdate.substring(0, 4) +
            "/" +
            this.state.data.payload.data.lastupdate.substring(4, 6) +
            "/" +
            this.state.data.payload.data.lastupdate.substring(6, 8) +
            " " +
            this.state.data.payload.data.lastupdate.substring(8, 10) +
            ":" +
            this.state.data.payload.data.lastupdate.substring(10, 12)
            : ""}
          <br />
          {i18n.t("Home.Disclaimer")}
          <br />
          <div></div>
        </div>
      </div>
    );
  }
}
